__turbopack_context__.v({
  "arrowBadge": "explainers-client-module__tuge6q__arrowBadge",
  "body": "explainers-client-module__tuge6q__body",
  "bodyInner": "explainers-client-module__tuge6q__bodyInner",
  "count": "explainers-client-module__tuge6q__count",
  "eyebrow": "explainers-client-module__tuge6q__eyebrow",
  "footerRule": "explainers-client-module__tuge6q__footerRule",
  "glass": "explainers-client-module__tuge6q__glass",
  "h1": "explainers-client-module__tuge6q__h1",
  "hero": "explainers-client-module__tuge6q__hero",
  "heroFrame": "explainers-client-module__tuge6q__heroFrame",
  "heroInner": "explainers-client-module__tuge6q__heroInner",
  "heroScrim": "explainers-client-module__tuge6q__heroScrim",
  "heroShader": "explainers-client-module__tuge6q__heroShader",
  "hint": "explainers-client-module__tuge6q__hint",
  "lede": "explainers-client-module__tuge6q__lede",
  "list": "explainers-client-module__tuge6q__list",
  "page": "explainers-client-module__tuge6q__page",
  "phrase": "explainers-client-module__tuge6q__phrase",
  "row": "explainers-client-module__tuge6q__row",
  "rowBlurb": "explainers-client-module__tuge6q__rowBlurb",
  "rowHead": "explainers-client-module__tuge6q__rowHead",
  "rowIcon": "explainers-client-module__tuge6q__rowIcon",
  "rowName": "explainers-client-module__tuge6q__rowName",
  "rowText": "explainers-client-module__tuge6q__rowText",
  "searchPill": "explainers-client-module__tuge6q__searchPill",
  "sectionLabel": "explainers-client-module__tuge6q__sectionLabel",
});
